import moment from 'moment';
import { CardStatus, WorkerCardType } from 'apollo/generated/client-operations';
import { BadgeChecklist } from 'components/badgeChecklist/BadgeChecklist';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import { WorkerCard } from 'containers/worker/modals/badgeModal/components/types';
import { ReactivateWorkerBadgeData } from './types';

export const getFormInputs = (args: {
  workerCard: WorkerCard;
}): TypedFormInputs<ReactivateWorkerBadgeData> => {
  const { workerCard } = args;
  const { isTemporary } = workerCard ?? {};

  return {
    expirationDate: {
      element: FormInputTypes.DatePicker,
      label: 'Expiration date',
      elementProps: {
        minDate: moment(),
        showDefaultIcon: true,
        numberOfMonths: 1,
      },
      validation: { required: isTemporary },
      layout: isTemporary
        ? [GridColSpan.SpanFull, GridColSpan.SmSpan3]
        : 'odin-hidden',
    },
    badges: {
      element: FormInputTypes.CustomInput,
      elementProps: {
        customInput: BadgeChecklist,
      },
      layout: GridColSpan.SpanFull,
    },
  };
};

export const getFormDefaultValues = (args: {
  workerCard: WorkerCard;
  workerCards: WorkerCard[];
  expirationDate?: moment.Moment;
}): ReactivateWorkerBadgeData => {
  const { workerCard, workerCards, expirationDate } = args;
  const { isTemporary, expiredAt } = workerCard ?? {};

  const getExpirationDate = (): moment.Moment | null => {
    if (!isTemporary) return null;
    if (expirationDate) return expirationDate;
    const newExpiredAt = moment().add({ day: 1 }).endOf('day');
    const currentExpiredAt = expiredAt && moment(expiredAt);
    return currentExpiredAt && currentExpiredAt.isAfter(newExpiredAt)
      ? currentExpiredAt
      : newExpiredAt;
  };

  return {
    expirationDate: getExpirationDate(),
    badges:
      workerCards
        ?.filter(
          ({ cardStatus, workerCardFormat }) =>
            cardStatus === CardStatus.Active &&
            workerCardFormat.cardType === WorkerCardType.Proximity,
        )
        ?.map((wc) => ({ workerCard: wc, selected: true })) ?? null,
  };
};
